"use strict";

let klaviyoSubscribeLoaded = false;
const klaviyoSubscribeUrl = '//www.klaviyo.com/media/js/public/klaviyo_subscribe.js';
const contactForms = document.querySelectorAll('.section__contact-form');

contactForms.forEach(contactForm => {
    contactForm.querySelector('.field__input').addEventListener('focus', async () => {
        if (!klaviyoSubscribeLoaded) {
            await calpak.loadScript(klaviyoSubscribeUrl);
        }

        if (!contactForm.classList.contains('section__contact-form--attached')) {
            contactForm.classList.add('section__contact-form--attached');
            KlaviyoSubscribe.attachToModalForm(`.section__contact-form[data-id="${contactForm.getAttribute('data-id')}"]`,
                {
                    success: function ($form) {
                        var email = $form.find('[name="email"]').val();
                        // console.log(email)

                        // LiveConnect Tag
                        window.liQ = window.liQ || [];
                        window.liQ.push({
                            "event": "conversion",
                            "name": "email_signup",
                            "email": email
                        });

                    }
                });
        }
    });
});
